// Whether a given profile has already been unlocked by a company/provider,
// per their `provider.unlockedApplicants` list.
export function isProfileUnlocked(unlockedApplicants, profileId) {
  const match = (unlockedApplicants || []).find(
    (item) => item.profile === profileId
  )
  return !!match
}

// A job's matches minus the jobseekers the company has declined for that
// job -- what the "Matches for this job" tab lists, and what the Matches
// stat on Job Postings and the job view counts (GFB-1372).
export function activeJobMatches(job, profilesRejected = []) {
  return (job?.matches || []).filter(
    (match) =>
      !profilesRejected.some(
        (declined) =>
          declined.profile === match._id &&
          declined.type === "job-application" &&
          declined.job === job._id
      )
  )
}
